(() => {
  const root = document.querySelector('[data-powdi-quiz]');
  if (!root) return;

  const config = window.POWDI_QUIZ_CONFIG;
  if (!config) return;

  const questions = config.questions || [];
  const directions = config.meta?.directions || [];
  const texts = config.resultTexts || {};
  const events = config.analytics?.events || {};
  const rootPath = window.Shopify?.routes?.root || '/';
  const moneyFormat = root.dataset.moneyFormat || '{{amount}} €';
  const starSrc = root.dataset.starSrc || '';
  const radioOffSrc = root.dataset.radioOff || '';
  const radioOnSrc = root.dataset.radioOn || '';
  const checkCircleSrc = root.dataset.checkCircle || '';
  const iconMinusSrc = root.dataset.iconMinus || '';
  const iconPlusSrc = root.dataset.iconPlus || '';
  const iconChevronSrc = root.dataset.iconChevron || '';
  const allProductsUrl = root.dataset.allProductsUrl || '/collections/all';
  const hintLabel = root.dataset.hintLabel || 'Pasirink vieną opciją';
  const nextLabel = root.dataset.nextLabel || 'Toliau';
  const onceLabel = root.dataset.onceLabel || 'Vieną kartą';
  const subscribeLabel = root.dataset.subscribeLabel || 'Prenumeruok ir sutaupyk';
  const saveLabel = root.dataset.saveLabel || 'Sutaupyk';
  const freqLabel = root.dataset.freqLabel || 'Pristatysime kas 30 dienų';
  const subBenefit1 = root.dataset.subBenefit1 || 'Sutaupai su kiekvienu pristatymu';
  const subBenefit2 = root.dataset.subBenefit2 || 'Pristatome automatiškai – niekada nepritrūksi';
  const subBenefit3 = root.dataset.subBenefit3 || 'Keisk dažnumą ar atšauk bet kada';
  const moreHeading = root.dataset.moreHeading || 'Išsamiau apie rekomendacijas';
  const emailConsent = root.dataset.emailConsent || '';
  const privacyUrl = root.dataset.privacyUrl || '';
  const privacyLabel = root.dataset.privacyLabel || 'Privatumo politika';

  const stepEl = root.querySelector('[data-quiz-step]');
  const resultEl = root.querySelector('[data-quiz-result]');
  const progressEl = root.querySelector('[data-quiz-progress]');
  const contentEl = root.querySelector('[data-quiz-content]');
  const questionEl = root.querySelector('[data-quiz-question]');
  const hintEl = root.querySelector('[data-quiz-hint]');
  const answersEl = root.querySelector('[data-quiz-answers]');
  const backBtn = root.querySelector('[data-quiz-back]');
  const nextBtn = root.querySelector('[data-quiz-next]');
  const productCache = new Map();
  let paintedIndex = -1;
  const planCatalog = loadPlanCatalog();

  const state = {
    index: 0,
    answers: {},
    score: Object.fromEntries(directions.map((key) => [key, 0])),
    segment: 'naujokas',
    format: 'bet_koks',
    scope: 'vienas',
    started: false,
    result: null,
    forcedDirection: null,
    querySegment: null,
    queryFormat: null,
    queryScope: null,
    heroProduct: null,
    variantId: null,
    cartError: '',
    sellingPlanId: null,
    purchaseMode: 'once',
    quantity: 1,
  };

  function track(key, params) {
    const name = events[key] || key;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }

  function entryPoint() {
    const fromQuery = new URLSearchParams(window.location.search).get('entry');
    const allowed = config.analytics?.entryPoints || [];
    if (fromQuery && allowed.includes(fromQuery)) return fromQuery;
    if (document.referrer.includes('/pages/') === false && document.referrer) return 'banner';
    return 'menu';
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    const formatted = value.toFixed(2).replace('.', ',');
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  function imageUrl(product, variant) {
    const src = variant?.featured_image?.src || product?.featured_image;
    if (!src) return '';
    return src.replace(/^\/\//, 'https://');
  }

  function variantWeight(variant) {
    if (!variant) return '';
    if (variant.option1 && variant.option1 !== 'Default Title') return variant.option1;
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    return '';
  }

  function loadPlanCatalog() {
    const node = root.querySelector('[data-quiz-plans]');
    if (!node) return {};
    try {
      const parsed = JSON.parse(node.textContent || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function applyPlanCatalog(product) {
    if (!product?.handle) return product;
    const extra = planCatalog[product.handle];
    if (!extra) return product;
    if (!product.selling_plan_groups?.length && extra.selling_plan_groups?.length) {
      product.selling_plan_groups = extra.selling_plan_groups;
    }
    if (typeof extra.requires_selling_plan === 'boolean') {
      product.requires_selling_plan = extra.requires_selling_plan;
    }
    (product.variants || []).forEach((variant) => {
      if (usableAllocations(variant.selling_plan_allocations)) return;
      const allocations = usableAllocations(extra.variants?.[String(variant.id)]);
      if (allocations) variant.selling_plan_allocations = allocations;
    });
    return product;
  }

  function usableAllocations(list) {
    if (!Array.isArray(list) || !list.length) return null;
    if (list.some((item) => !item || item.error || (item.selling_plan_id == null && item.selling_plan?.id == null))) {
      return null;
    }
    return list;
  }

  function sameId(a, b) {
    return a != null && b != null && String(a) === String(b);
  }

  function localizePlan(raw) {
    const text = String(raw || '').trim();
    const match = text.match(/^deliver every\s+(?:(\d+)\s+)?(week|month|day)s?\b/i);
    if (!match) return text;
    const count = Number(match[1] || 1);
    const unit = match[2].toLowerCase();
    if (unit === 'week') {
      if (count === 1) return 'Kiekvieną savaitę';
      if (count <= 9) return `Kas ${count} savaites`;
      return `Kas ${count} savaičių`;
    }
    if (unit === 'month') return count === 1 ? 'Kas 1 mėnesį' : `Kas ${count} mėnesius`;
    if (count === 1) return 'Kas 1 dieną';
    if (count <= 9) return `Kas ${count} dienas`;
    return `Kas ${count} dienų`;
  }

  function planLabel(plan) {
    const option = plan?.options?.[0];
    return localizePlan((option && option.value) || plan?.name || '');
  }

  function sellingPlanParam(id) {
    if (id == null || id === '') return null;
    const asNumber = Number(id);
    if (Number.isFinite(asNumber) && asNumber > 0) return asNumber;
    const digits = String(id).match(/(\d+)\s*$/);
    return digits ? Number(digits[1]) : null;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function purchasableVariants(product) {
    return (product?.variants || []).filter((variant) => variant && variant.available);
  }

  function variantSize(variant) {
    const label = `${variant?.option1 || ''} ${variant?.title || ''}`;
    const grams = label.match(/(\d+(?:[.,]\d+)?)\s*g\b/i);
    if (grams) return Number(grams[1].replace(',', '.'));
    return Number(variant?.price) || Number.MAX_SAFE_INTEGER;
  }

  function variantsForChoice(product) {
    const available = purchasableVariants(product);
    const source = available.length ? available : product?.variants || [];
    return source.slice().sort((a, b) => {
      const bySize = variantSize(a) - variantSize(b);
      if (bySize) return bySize;
      return (Number(a.price) || 0) - (Number(b.price) || 0);
    });
  }

  function shortName(handle) {
    return (config.shortNames || {})[handle] || '';
  }

  function resultHeadline(handle) {
    const name = shortName(handle);
    const prefix = texts.headlinePrefix || '';
    return name ? `${prefix}${name}` : prefix.trim();
  }

  function resultIntro() {
    const direction = texts.introDirection?.[state.result?.direction] || '';
    const format = texts.introFormat?.[state.format] || '';
    const third =
      state.scope === 'rinkinys'
        ? texts.introScope?.rinkinys || ''
        : texts.introSegment?.[state.segment] || '';
    if (!direction || !format || !third) return '';
    const end = texts.introEnd || '';
    const endText = end.startsWith('.') || end.startsWith(' ') ? end : ` ${end}`;
    return `${texts.introStart || ''}${direction}, ${format} ir ${third}${endText}`;
  }

  function currentVariant() {
    const product = state.heroProduct;
    if (!product) return null;
    return (product.variants || []).find((item) => sameId(item.id, state.variantId)) || purchasableVariants(product)[0] || null;
  }

  function syncPlanForVariant() {
    const variant = currentVariant();
    const plans = sellingPlans(state.heroProduct, variant);
    if (!plans.length) {
      state.sellingPlanId = null;
      if (state.purchaseMode === 'subscribe') state.purchaseMode = 'once';
      return plans;
    }
    const stillValid = plans.some((plan) => sameId(plan.id, state.sellingPlanId));
    if (!stillValid) state.sellingPlanId = plans[0].id;
    return plans;
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    const request = fetch(`${rootPath}products/${handle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error('product');
        return response.json();
      })
      .then((product) => applyPlanCatalog(product));
    productCache.set(handle, request.catch(() => {
      productCache.delete(handle);
      return null;
    }));
    return productCache.get(handle);
  }

  function selectedAnswer() {
    const question = questions[state.index];
    if (!question) return null;
    const id = state.answers[question.id];
    return question.answers.find((answer) => answer.id === id) || null;
  }

  function applyAnswer(answer) {
    if (!answer) return;
    if (answer.scores) {
      Object.keys(answer.scores).forEach((key) => {
        state.score[key] = (state.score[key] || 0) + answer.scores[key];
      });
    }
    if (answer.sets) {
      if (answer.sets.segment) state.segment = answer.sets.segment;
      if (answer.sets.format) state.format = answer.sets.format;
      if (answer.sets.scope) state.scope = answer.sets.scope;
    }
  }

  function recompute() {
    state.score = Object.fromEntries(directions.map((key) => [key, 0]));
    state.segment = 'naujokas';
    state.format = 'bet_koks';
    state.scope = 'vienas';
    questions.forEach((question) => {
      const id = state.answers[question.id];
      const answer = question.answers.find((item) => item.id === id);
      applyAnswer(answer);
    });
  }

  function resolveDirection() {
    if (state.forcedDirection && directions.includes(state.forcedDirection)) {
      return state.forcedDirection;
    }
    const q2 = questions.find((question) => question.axis === 'tikslas');
    const q2Answer = q2 ? q2.answers.find((item) => item.id === state.answers[q2.id]) : null;
    const max = Math.max(...directions.map((key) => state.score[key] || 0));
    const tied = directions.filter((key) => (state.score[key] || 0) === max);
    if (tied.length === 1) return tied[0];
    const fromGoal = tied.find((key) => q2Answer?.scores?.[key]);
    return fromGoal || tied[0] || directions[0];
  }

  function resolveResult() {
    recompute();
    if (state.querySegment) state.segment = state.querySegment;
    if (state.queryFormat) state.format = state.queryFormat;
    if (state.queryScope) state.scope = state.queryScope;
    const direction = resolveDirection();
    const cell =
      config.matrix?.[direction]?.[state.segment]?.[state.format] ||
      config.matrix?.[direction]?.naujokas?.bet_koks;
    if (!cell) return null;

    let hero = cell.hero;
    let alt = (cell.alt || []).slice();
    let usedBundle = false;
    let bundleFallback = false;

    if (state.scope === 'rinkinys') {
      const bundleHandle = config.bundleMatrix?.[direction];
      if (bundleHandle) {
        hero = bundleHandle;
        usedBundle = true;
        alt = (cell.alt || []).concat(cell.hero).filter((handle, index, list) => {
          return handle && handle !== hero && list.indexOf(handle) === index;
        }).slice(0, 2);
      } else {
        bundleFallback = true;
      }
    }

    return {
      direction,
      hero,
      alt,
      usedBundle,
      bundleFallback,
      singleHero: cell.hero,
      singleAlt: (cell.alt || []).slice(0, 2),
    };
  }

  function renderProgress() {
    progressEl.innerHTML = questions
      .map((_, index) => {
        const current = index === state.index;
        const done = index < state.index;
        const className = current || done ? 'is-active' : '';
        return `<span class="powdi-quiz__dot ${className}" aria-current="${current ? 'step' : 'false'}">${index + 1}</span>`;
      })
      .join('');
  }

  function fadeMs() {
    const raw = getComputedStyle(root).getPropertyValue('--powdi-quiz-fade').trim();
    const value = Number.parseFloat(raw);
    return Number.isFinite(value) ? value : 150;
  }

  function paintStep() {
    const question = questions[state.index];
    if (!question) return;
    questionEl.textContent = question.text;
    hintEl.textContent = hintLabel;
    const selectedId = state.answers[question.id];
    answersEl.innerHTML = question.answers
      .map((answer) => {
        const pressed = answer.id === selectedId ? 'true' : 'false';
        return `<button type="button" class="powdi-quiz__option" data-answer="${answer.id}" aria-pressed="${pressed}">${answer.text}</button>`;
      })
      .join('');
    nextBtn.disabled = !selectedId;
    nextBtn.textContent = nextLabel;
  }

  function renderStep() {
    const question = questions[state.index];
    if (!question) return;
    root.classList.remove('is-result');
    stepEl.hidden = false;
    resultEl.hidden = true;
    backBtn.hidden = state.index === 0;
    renderProgress();

    const questionChanged = paintedIndex !== -1 && paintedIndex !== state.index;
    paintedIndex = state.index;

    if (questionChanged && contentEl && fadeMs() > 1) {
      contentEl.classList.add('is-exiting');
      window.setTimeout(() => {
        paintStep();
        requestAnimationFrame(() => {
          contentEl.classList.remove('is-exiting');
        });
      }, fadeMs());
    } else {
      if (contentEl) contentEl.classList.remove('is-exiting');
      paintStep();
    }

    persist(false);
  }

  function productTags(product) {
    return (product?.tags || []).map((tag) => String(tag).toLowerCase().trim());
  }

  function starsHtml() {
    if (!starSrc) return '';
    return `<span class="powdi-quiz__stars" aria-hidden="true">${Array.from({ length: 5 }, () => `<img src="${starSrc}" width="15" height="14" alt="">`).join('')}</span>`;
  }

  function productCardHtml(product, variant, extraClass) {
    const image = imageUrl(product, variant);
    const compare = variant?.compare_at_price && variant.compare_at_price > variant.price;
    return `
      <article class="powdi-quiz__card ${extraClass || ''}" data-variant-id="${variant?.id || ''}">
        <div class="powdi-quiz__card-media">
          ${image ? `<img src="${image}" alt="${product.title.replace(/"/g, '&quot;')}" width="70" height="70">` : ''}
        </div>
        <div class="powdi-quiz__card-copy">
          <h3 class="powdi-quiz__card-title">${product.title}</h3>
          ${productTags(product).includes('naujiena') ? '<span class="powdi-quiz__new">Naujiena</span>' : ''}
          <p class="powdi-quiz__card-meta">${variantWeight(variant)}</p>
          <p class="powdi-quiz__price">
            ${compare ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}
            <strong>${formatMoney(variant.price)}</strong>
          </p>
          <div class="powdi-quiz__rating">
            ${starsHtml()}
            <div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}"></div>
          </div>
        </div>
      </article>
    `;
  }

  function sellingPlans(product, variant) {
    const names = new Map();
    const groupPlans = [];

    (product?.selling_plan_groups || []).forEach((group) => {
      (group.selling_plans || []).forEach((plan) => {
        if (plan?.id == null) return;
        const id = String(plan.id);
        names.set(id, planLabel(plan));
        const adjustment = plan.price_adjustments?.[0];
        let price = Number(variant?.price || 0);
        if (adjustment?.value_type === 'percentage' && adjustment.value != null) {
          price = Math.round((price * (100 - Number(adjustment.value))) / 100);
        } else if (adjustment?.value_type === 'price' && adjustment.value != null) {
          price = Math.round(Number(adjustment.value));
        }
        groupPlans.push({
          id,
          name: planLabel(plan) || freqLabel,
          price,
          compare: Number(variant?.price || 0),
        });
      });
    });

    const allocations = (variant?.selling_plan_allocations || []).filter((item) => {
      return item && !item.error && (item.selling_plan_id != null || item.selling_plan?.id != null);
    });

    if (allocations.length) {
      return allocations.map((item) => {
        const id = String(item.selling_plan_id ?? item.selling_plan.id);
        return {
          id,
          name: planLabel(item.selling_plan) || names.get(id) || freqLabel,
          price: Number(item.price != null ? item.price : variant?.price || 0),
          compare: Number(variant?.price || 0),
        };
      });
    }

    return groupPlans;
  }

  function currentPrice() {
    const variant = currentVariant();
    if (!variant) return 0;
    if (state.purchaseMode === 'subscribe' && state.sellingPlanId) {
      const plan = sellingPlans(state.heroProduct, variant).find((item) => sameId(item.id, state.sellingPlanId));
      return (plan?.price || variant.price) * state.quantity;
    }
    return variant.price * state.quantity;
  }

  function radioHtml() {
    return `<span class="powdi-quiz__radio" aria-hidden="true">
      ${radioOffSrc ? `<img class="powdi-quiz__radio-off" src="${radioOffSrc}" width="24" height="24" alt="">` : ''}
      ${radioOnSrc ? `<img class="powdi-quiz__radio-on" src="${radioOnSrc}" width="24" height="24" alt="">` : ''}
    </span>`;
  }

  function freqHtml(plans, selectedId) {
    const chevron = iconChevronSrc
      ? `<img class="powdi-quiz__freq-chevron" src="${iconChevronSrc}" width="16" height="16" alt="">`
      : '';
    if (!plans.length) return '';
    if (plans.length === 1) {
      return `<span class="powdi-quiz__freq">
        <span>${escapeHtml(plans[0].name || freqLabel)}</span>
        ${chevron}
      </span>`;
    }
    return `<label class="powdi-quiz__freq">
      <select data-quiz-freq aria-label="${escapeHtml(freqLabel)}">
        ${plans
          .map(
            (plan) =>
              `<option value="${escapeHtml(plan.id)}" ${sameId(plan.id, selectedId) ? 'selected' : ''}>${escapeHtml(plan.name || freqLabel)}</option>`
          )
          .join('')}
      </select>
      ${chevron}
    </label>`;
  }

  function renderBuyBox() {
    const product = state.heroProduct;
    if (!product) return;
    const variant = currentVariant() || product.variants?.[0];
    if (!variant) return;
    const plans = sellingPlans(product, variant);
    const selectedPlan = plans.find((item) => sameId(item.id, state.sellingPlanId)) || plans[0];
    const subscribeOn = state.purchaseMode === 'subscribe' && plans.length;
    const box = resultEl.querySelector('[data-quiz-buy]');
    const savePct = selectedPlan && variant.price
      ? Math.round((1 - selectedPlan.price / variant.price) * 100)
      : 0;
    const subscribePrice = selectedPlan ? selectedPlan.price : variant.price;
    box.innerHTML = `
      <div class="powdi-quiz__purchase">
        <div class="powdi-quiz__plans" role="radiogroup">
          <button type="button" class="powdi-quiz__plan ${subscribeOn ? '' : 'is-selected'}" data-mode="once" aria-pressed="${subscribeOn ? 'false' : 'true'}">
            ${radioHtml()}
            <span>${onceLabel}</span>
            <strong>${formatMoney(variant.price)}</strong>
          </button>
          ${plans.length ? `
            <div class="powdi-quiz__plan powdi-quiz__plan--sub ${subscribeOn ? 'is-selected' : ''}" data-mode="subscribe" aria-pressed="${subscribeOn ? 'true' : 'false'}">
              <span class="powdi-quiz__plan-top">
                ${radioHtml()}
                <span>${subscribeLabel}</span>
                ${savePct > 0 ? `<em>${saveLabel} ${savePct}%</em>` : ''}
                <span class="powdi-quiz__plan-price">
                  ${savePct > 0 ? `<s>${formatMoney(variant.price)}</s>` : ''}
                  <strong>${formatMoney(subscribePrice)}</strong>
                </span>
              </span>
              ${subscribeOn ? `
                ${freqHtml(plans, selectedPlan?.id)}
                <ul class="powdi-quiz__benefits">
                  <li>${checkCircleSrc ? `<img src="${checkCircleSrc}" width="16" height="16" alt="">` : ''}${subBenefit1}</li>
                  <li>${checkCircleSrc ? `<img src="${checkCircleSrc}" width="16" height="16" alt="">` : ''}${subBenefit2}</li>
                  <li>${checkCircleSrc ? `<img src="${checkCircleSrc}" width="16" height="16" alt="">` : ''}${subBenefit3}</li>
                </ul>
              ` : ''}
            </div>
          ` : ''}
        </div>
        <div class="powdi-quiz__cart-row">
          <div class="powdi-quiz__qty">
            <button type="button" data-qty="-1" aria-label="-">${iconMinusSrc ? `<img src="${iconMinusSrc}" width="22" height="22" alt="">` : '−'}</button>
            <span data-qty-value>${state.quantity}</span>
            <button type="button" data-qty="1" aria-label="+">${iconPlusSrc ? `<img src="${iconPlusSrc}" width="22" height="22" alt="">` : '+'}</button>
          </div>
          <button type="button" class="powdi-quiz__add" data-add-hero ${variant.available ? '' : 'disabled'}>
            <span>${variant.available ? texts.ctaHero || 'Į krepšelį' : productTags(product).includes('netrukus') ? 'Netrukus' : 'Išparduota'}</span>
            ${variant.available ? `<span aria-hidden="true">⋅</span><span>${formatMoney(currentPrice())}</span>` : ''}
          </button>
        </div>
        ${state.cartError ? `<p class="powdi-quiz__cart-error" role="alert">${escapeHtml(state.cartError)}</p>` : ''}
      </div>
    `;
  }

  function refreshJudgeme() {
    if (window.jdgm?.customizeBadges) window.jdgm.customizeBadges();
  }

  async function renderResult() {
    const result = resolveResult();
    state.result = result;
    if (!result) return;

    stepEl.hidden = true;
    resultEl.hidden = false;
    root.classList.add('is-result');

    let hero = await fetchProduct(result.hero);
    if (!purchasableVariants(hero).length && result.singleHero && result.singleHero !== result.hero) {
      const fallback = await fetchProduct(result.singleHero);
      if (purchasableVariants(fallback).length) {
        result.usedBundle = false;
        result.bundleSoldOut = true;
        result.hero = result.singleHero;
        result.alt = result.singleAlt || [];
        hero = fallback;
      }
    }
    state.heroProduct = hero;
    state.cartError = '';

    const eyebrowEl = resultEl.querySelector('[data-quiz-eyebrow]');
    if (eyebrowEl) eyebrowEl.textContent = texts.eyebrow || '';
    resultEl.querySelector('[data-quiz-headline]').textContent = resultHeadline(result.hero);
    resultEl.querySelector('[data-quiz-sub]').textContent = resultIntro();

    const whyEl = resultEl.querySelector('[data-quiz-why]');
    const whyText = (config.heroWhy || {})[result.hero] || '';
    if (whyEl) {
      whyEl.hidden = !whyText;
      const whyLabel = resultEl.querySelector('[data-quiz-why-label]');
      const whyBody = resultEl.querySelector('[data-quiz-why-text]');
      if (whyLabel) whyLabel.textContent = texts.heroWhyLabel || '';
      if (whyBody) whyBody.textContent = whyText;
    }

    const noteEl = resultEl.querySelector('[data-quiz-note]');
    if (result.bundleSoldOut) {
      noteEl.hidden = false;
      noteEl.textContent =
        texts.bundleSoldOut ||
        'Rinkinys šiuo metu išparduotas, todėl siūlome produktą, kurį gali įsidėti į krepšelį.';
    } else if (result.bundleFallback) {
      noteEl.hidden = false;
      noteEl.textContent = texts.bundleFallback || '';
    } else {
      noteEl.hidden = true;
    }

    const variantsEl = resultEl.querySelector('[data-quiz-variants]');
    if (!hero) {
      variantsEl.innerHTML = '';
      resultEl.querySelector('[data-quiz-buy]').innerHTML = '';
    } else {
      const variants = variantsForChoice(hero);
      state.variantId = variants[0]?.id;
      const plans = syncPlanForVariant();
      state.purchaseMode = plans.length ? 'subscribe' : 'once';
      variantsEl.innerHTML = variants.map((variant) => productCardHtml(hero, variant)).join('');
      const firstCard = variantsEl.querySelector('.powdi-quiz__card');
      if (firstCard) firstCard.classList.add('is-selected');
      renderBuyBox();
    }

    const alts = await Promise.all(result.alt.map((handle) => fetchProduct(handle)));
    const altsEl = resultEl.querySelector('[data-quiz-alts]');
    altsEl.innerHTML = alts
      .filter(Boolean)
      .map((product) => {
        const variant = variantsForChoice(product)[0] || null;
        const canBuy = !!variant?.available;
        const productUrl = `${rootPath}products/${product.handle}`;
        const reason = (config.altReason || {})[product.handle] || '';
        return `
          <article class="powdi-quiz__alt">
            <a class="powdi-quiz__alt-media" href="${productUrl}">
              ${imageUrl(product, variant) ? `<img src="${imageUrl(product, variant)}" alt="${product.title.replace(/"/g, '&quot;')}" width="217" height="217">` : ''}
            </a>
            <div class="powdi-quiz__alt-copy">
              <h3><a href="${productUrl}">${product.title}</a></h3>
              ${productTags(product).includes('naujiena') ? '<span class="powdi-quiz__new">Naujiena</span>' : ''}
              <p>${variantWeight(variant)}</p>
              <div class="powdi-quiz__rating">
                ${starsHtml()}
                <div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}"></div>
              </div>
              ${reason ? `<p class="powdi-quiz__alt-desc">${escapeHtml(reason)}</p>` : ''}
              <p class="powdi-quiz__price"><strong>${formatMoney(variant?.price)}</strong></p>
              <button type="button" class="powdi-quiz__add powdi-quiz__alt-add" data-add-variant="${variant?.id || ''}" data-handle="${product.handle}" ${canBuy ? '' : 'disabled'}>
                ${canBuy ? texts.ctaAlt || texts.ctaHero || 'Į krepšelį' : productTags(product).includes('netrukus') ? 'Netrukus' : 'Išparduota'}
              </button>
            </div>
          </article>
        `;
      })
      .join('');

    const moreTitle = resultEl.querySelector('.powdi-quiz__more-title');
    if (moreTitle) moreTitle.textContent = texts.altHeading || moreHeading;
    const altIntro = resultEl.querySelector('[data-quiz-alt-intro]');
    if (altIntro) altIntro.textContent = texts.altIntro || '';
    const retake = resultEl.querySelector('[data-quiz-retake]');
    if (retake) retake.textContent = texts.retakeLabel || 'Pakartoti testą';

    const allLink = resultEl.querySelector('[data-quiz-all]');
    allLink.textContent = texts.ctaAll || 'Visi produktai →';
    allLink.href = allProductsUrl;

    const offer = resultEl.querySelector('[data-quiz-email-offer]');
    const note = resultEl.querySelector('[data-quiz-email-note]');
    if (offer) offer.textContent = texts.emailOffer || '';
    if (note) note.textContent = texts.emailNote || '';

    refreshJudgeme();
    persist(true);
    syncResultUrl();
    track('result', {
      direction: result.direction,
      segment: state.segment,
      format: state.format,
      scope: state.scope,
    });
  }

  function applyResultQuery() {
    const params = new URLSearchParams(window.location.search);
    const direction = params.get('rezultatas');
    if (!direction || !directions.includes(direction)) return false;
    state.forcedDirection = direction;
    const segment = params.get('segmentas');
    const format = params.get('formatas');
    const scope = params.get('apimtis');
    if (segment === 'naujokas' || segment === 'patyres') state.querySegment = segment;
    if (format === 'tabletes' || format === 'milteliai' || format === 'bet_koks') {
      state.queryFormat = format;
    }
    if (scope === 'vienas' || scope === 'rinkinys') state.queryScope = scope;
    return true;
  }

  function shopOrigin() {
    return (root.dataset.shopUrl || 'https://powdi.lt').replace(/\/$/, '');
  }

  function publicResultUrl(result) {
    const url = new URL(`${shopOrigin()}${window.location.pathname}`);
    url.searchParams.set('rezultatas', result.direction);
    url.searchParams.set('segmentas', state.segment);
    url.searchParams.set('formatas', state.format);
    url.searchParams.set('apimtis', state.scope);
    return url.toString();
  }

  function productPageUrl(handle) {
    const path = `${rootPath}products/${handle}`.replace(/\/{2,}/g, '/');
    return `${shopOrigin()}${path.startsWith('/') ? path : `/${path}`}`;
  }

  function mailImageUrl(product) {
    const raw = product?.featured_image;
    const src = typeof raw === 'string' ? raw : raw?.src || '';
    if (!src) return '';
    const absolute = /^https?:/i.test(src) ? src : `https:${src.startsWith('//') ? src : `//${src}`}`;
    try {
      const url = new URL(absolute);
      url.searchParams.set('width', '600');
      return url.toString();
    } catch (error) {
      return absolute;
    }
  }

  async function recommendationFields(result) {
    const handles = [result.hero].concat(result.alt || []).filter(Boolean).slice(0, 3);
    const loaded = (await Promise.all(handles.map((handle) => fetchProduct(handle)))).filter(Boolean);
    const fields = { product_count: loaded.length };
    for (let index = 0; index < 3; index += 1) {
      const product = loaded[index];
      const slot = index + 1;
      fields[`product_${slot}_name`] = product?.title || '';
      fields[`product_${slot}_image`] = product ? mailImageUrl(product) : '';
      fields[`product_${slot}_url`] = product?.handle ? productPageUrl(product.handle) : '';
    }
    return fields;
  }

  function syncResultUrl() {
    if (!state.result || !window.history?.replaceState) return;
    const params = new URLSearchParams(window.location.search);
    params.set('rezultatas', state.result.direction);
    params.set('segmentas', state.segment);
    params.set('formatas', state.format);
    params.set('apimtis', state.scope);
    const next = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (next !== current) window.history.replaceState(null, '', next);
  }

  function withOmnisend(done) {
    window.omnisend = window.omnisend || [];
    if (typeof window.omnisend.identifyContact === 'function') {
      done(window.omnisend);
      return;
    }
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (typeof window.omnisend.identifyContact === 'function' || tries > 20) {
        window.clearInterval(timer);
        done(window.omnisend);
      }
    }, 250);
  }

  function trackOmnisendQuiz(email) {
    const result = state.result;
    if (!result || !email) return;
    const send = async () => {
      const products = await recommendationFields(result);
      window.omnisend = window.omnisend || [];
      window.omnisend.push([
        'track',
        'savijautos testas',
        {
          origin: 'api',
          properties: Object.assign(
            {
              email,
              result_name: shortName(result.hero) || result.hero,
              result_direction: (texts.directionLabels || {})[result.direction] || result.direction,
              result_url: publicResultUrl(result),
            },
            products
          ),
        },
      ]);
    };
    withOmnisend((omnisend) => {
      let pending = null;
      if (typeof omnisend.identifyContact === 'function') {
        try {
          pending = omnisend.identifyContact({ email });
        } catch (error) {
          pending = null;
        }
      }
      if (pending && typeof pending.then === 'function') pending.then(send, send);
      else window.setTimeout(send, 400);
    });
  }

  async function addVariantToCart(variantId, options = {}) {
    const id = Number(variantId);
    if (!id) throw new Error('Nepavyko įdėti į krepšelį');
    const quantity = Math.max(1, Number(options.quantity) || 1);
    const sellingPlanId = sellingPlanParam(options.sellingPlanId);
    const payload = {
      items: [
        {
          id,
          quantity,
        },
      ],
    };
    if (sellingPlanId) payload.items[0].selling_plan = sellingPlanId;

    const sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((node) => {
      if (node.dataset.sectionId) sectionIds.push(node.dataset.sectionId);
    });
    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }

    const response = await fetch(`${rootPath}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok || json.status) {
      throw new Error(json.description || json.message || 'Nepavyko įdėti į krepšelį');
    }

    track('addToCart', {
      handle: options.handle || state.heroProduct?.handle,
      position: options.position || 'hero',
      selling_plan: sellingPlanId || undefined,
    });

    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const cart = await (await fetch(`${rootPath}cart.js`)).json();
      cart.sections = json.sections;
      const deferred = CartLinesUpdateEvent.createPromise();
      const line = { merchandiseId: String(id), quantity };
      if (sellingPlanId) line.sellingPlanId = String(sellingPlanId);
      let mappedCart;
      try {
        mappedCart = CartLinesUpdateEvent.createCartFromAjaxResponse(cart);
      } catch (error) {
        mappedCart = {
          id: cart.token,
          totalQuantity: cart.item_count || 0,
          lines: [],
          discountCodes: [],
        };
      }
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [line],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: mappedCart,
        detail: {
          items: cart.items,
          itemCount: cart.item_count,
          sections: json.sections,
          didError: false,
        },
      });
    } catch (error) {
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (typeof drawer?.open === 'function') drawer.open();
      else if (window.Shopify?.actions?.openCart) await window.Shopify.actions.openCart.run();
    }
  }

  answersEl.addEventListener('click', (event) => {
    const button = event.target.closest('[data-answer]');
    if (!button) return;
    const question = questions[state.index];
    state.answers[question.id] = button.dataset.answer;
    if (!state.started) {
      state.started = true;
      track('start', { entry_point: entryPoint() });
    }
    track('answer', { question_id: question.id, answer_id: button.dataset.answer });
    renderStep();
  });

  nextBtn.addEventListener('click', () => {
    if (!selectedAnswer()) return;
    if (state.index < questions.length - 1) {
      state.index += 1;
      renderStep();
      return;
    }
    renderResult();
  });

  backBtn.addEventListener('click', () => {
    if (state.index === 0) return;
    state.index -= 1;
    renderStep();
  });

  function retakeQuiz() {
    state.answers = {};
    state.index = 0;
    state.started = false;
    state.forcedDirection = null;
    state.querySegment = null;
    state.queryFormat = null;
    state.queryScope = null;
    state.result = null;
    state.heroProduct = null;
    state.variantId = null;
    state.cartError = '';
    paintedIndex = -1;
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* private mode */
    }
    if (window.history?.replaceState) {
      const params = new URLSearchParams(window.location.search);
      ['rezultatas', 'segmentas', 'formatas', 'apimtis'].forEach((key) => params.delete(key));
      const query = params.toString();
      const next = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
      window.history.replaceState(null, '', next);
    }
    renderStep();
    const scroller = document.querySelector('.page-wrapper') || document.scrollingElement;
    if (scroller) scroller.scrollTop = 0;
  }

  resultEl.addEventListener('click', (event) => {
    if (!event.target.closest('[data-quiz-retake]')) return;
    retakeQuiz();
  });

  resultEl.addEventListener('change', (event) => {
    const freq = event.target.closest('[data-quiz-freq]');
    if (!freq) return;
    state.purchaseMode = 'subscribe';
    state.sellingPlanId = String(freq.value);
    renderBuyBox();
  });

  resultEl.addEventListener('click', (event) => {
    if (event.target.closest('[data-quiz-freq]')) return;

    const card = event.target.closest('[data-quiz-variants] .powdi-quiz__card');
    if (card) {
      state.cartError = '';
      state.variantId = Number(card.dataset.variantId);
      resultEl.querySelectorAll('[data-quiz-variants] .powdi-quiz__card').forEach((node) => {
        node.classList.toggle('is-selected', node === card);
      });
      syncPlanForVariant();
      renderBuyBox();
      return;
    }

    const modeBtn = event.target.closest('[data-mode]');
    if (modeBtn) {
      state.cartError = '';
      state.purchaseMode = modeBtn.dataset.mode;
      if (state.purchaseMode === 'subscribe') syncPlanForVariant();
      renderBuyBox();
      return;
    }

    const qtyBtn = event.target.closest('[data-qty]');
    if (qtyBtn) {
      state.cartError = '';
      state.quantity = Math.max(1, state.quantity + Number(qtyBtn.dataset.qty));
      renderBuyBox();
      return;
    }

    const altAdd = event.target.closest('[data-add-variant]');
    if (altAdd) {
      event.preventDefault();
      if (altAdd.disabled || !altAdd.dataset.addVariant) return;
      const label = altAdd.textContent;
      altAdd.disabled = true;
      addVariantToCart(altAdd.dataset.addVariant, {
        handle: altAdd.dataset.handle,
        position: 'alt',
        quantity: 1,
      })
        .catch((error) => {
          altAdd.textContent = error.message || 'Nepavyko įdėti į krepšelį';
          window.setTimeout(() => {
            if (altAdd.isConnected) altAdd.textContent = label;
          }, 2500);
        })
        .finally(() => {
          altAdd.disabled = false;
        });
      return;
    }

    if (event.target.closest('[data-add-hero]')) {
      const addBtn = event.target.closest('[data-add-hero]');
      if (addBtn.disabled) return;
      const variant = currentVariant();
      if (!variant?.available) {
        state.cartError = 'Šis produktas šiuo metu išparduotas.';
        renderBuyBox();
        return;
      }
      state.cartError = '';
      addBtn.disabled = true;
      addVariantToCart(variant.id, {
        sellingPlanId: state.purchaseMode === 'subscribe' ? state.sellingPlanId : null,
        quantity: state.quantity,
        handle: state.heroProduct?.handle,
        position: 'hero',
      })
        .catch((error) => {
          state.cartError = error.message || 'Nepavyko įdėti į krepšelį';
        })
        .finally(() => {
          renderBuyBox();
        });
    }
  });

  const STORAGE_KEY = 'powdiQuiz';

  function persist(showResult) {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          answers: state.answers,
          index: state.index,
          showResult: !!showResult,
        })
      );
    } catch (error) {
      /* private mode */
    }
  }

  function restore() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved?.answers) return false;
      state.answers = saved.answers;
      state.index = Math.min(Number(saved.index) || 0, Math.max(questions.length - 1, 0));
      return !!saved.showResult;
    } catch (error) {
      return false;
    }
  }

  const emailForm = root.querySelector('[data-quiz-email-form], .powdi-quiz__email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', () => {
      persist(true);
      track('emailSubmit', { direction: state.result?.direction });
    });
  }

  if (hintEl) hintEl.textContent = hintLabel;
  const consentEl = root.querySelector('[data-quiz-email-consent]');
  if (consentEl) {
    const privacyLink = privacyUrl ? `<a href="${privacyUrl}">${privacyLabel}</a>` : '';
    consentEl.textContent = '';
    consentEl.appendChild(document.createTextNode(emailConsent ? `${emailConsent} ` : ''));
    if (privacyLink) {
      consentEl.insertAdjacentHTML('beforeend', privacyLink);
    }
  }

  if (emailForm) {
    emailForm.addEventListener('powdi:omnisend-subscribed', (event) => {
      trackOmnisendQuiz(event.detail?.email);
    });
  }

  if (applyResultQuery()) renderResult();
  else if (restore()) renderResult();
  else renderStep();
})();
